import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { MoveMode } from "./MoveMode";

const maximumNameLength = 28;

export function GetMoveConfirmationText(
    sourceNode: IWorkflowNode,
    parentNode: IWorkflowNode,
    moveMode: MoveMode,
    descendantCount: number
) {
    if (moveMode === MoveMode.AllChildrenAndDelete) {
        return `Move ${GetDescendantCountText(
            descendantCount
        )} from "${TruncateName(sourceNode.name)}" to "${TruncateName(
            parentNode.name
        )}", then delete "${TruncateName(sourceNode.name)}"?`;
    }

    if (moveMode === MoveMode.AllChildren) {
        return `Move ${GetDescendantCountText(
            descendantCount
        )} from "${TruncateName(sourceNode.name)}" to "${TruncateName(
            parentNode.name
        )}"? "${TruncateName(sourceNode.name)}" will remain.`;
    }

    return `Move "${TruncateName(
        sourceNode.name
    )}" and its children to the new parent "${TruncateName(
        parentNode.name
    )}" (#${parentNode.id})?`;
}

function GetDescendantCountText(descendantCount: number) {
    return `${descendantCount} ${
        descendantCount === 1 ? "descendant" : "descendants"
    }`;
}

function TruncateName(name: string) {
    if (name.length <= maximumNameLength) {
        return name;
    }

    return `${name.substring(0, maximumNameLength - 1).trimEnd()}…`;
}
